import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "gap"];
import styled from 'styled-components';
import { makeCustomProperty } from './utils';
import { LayoutBox } from './LayoutBox';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SpacingContainer = styled(LayoutBox).withConfig({
  displayName: "LayoutSpaceVertical__SpacingContainer",
  componentId: "l08ath-0"
})([">:not(:last-child){", " margin-block-end:var(--layout-lib-space-gap);}"], ({
  $gap
}) => `--layout-lib-space-gap: ${makeCustomProperty($gap)};`);
export const LayoutSpaceVertical = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      as,
      children,
      gap = 'space-lg'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(SpacingContainer, Object.assign({}, rest, {
    $gap: gap,
    forwardedAs: as,
    ref: ref,
    children: children
  }));
});